import React from "react";
import ImageAndTextDivider from "../Components/ImageAndTextDivider";
import ServiceIcon from "../Components/ServiceIcon";

const LocationAndServicesWoman: React.FC = () => {
  return (
    <div className="bg-primaryWoman">
      <ImageAndTextDivider
        background={"primaryWoman"}
        image={"bg-foto-location-1-woman"}
        header={"Location"}
        subHeader="Il nostro sogno ora è Il tuo."
        texts={[
          "ispirato alle sinuose forme delle dune del deserto elegante e raffinato come le maestose coste delle isole greche percepisci qualcosa ti senti subito più libera. finalmente sei a casa.",
          "Un luogo dove il tempo si ferma e solo tu sei la protagonista del magico viaggio che stai per intraprendere"
        ]}
        revertOrder={true}
        headerTextColor={"accentWoman"}
      />
      <ImageAndTextDivider
        background={"primaryWoman"}
        image={"bg-foto-servizi-1-woman"}
        header={"Servizi"}
        subHeader="... Ma nella nostra elite hair spa cosa si fa?"
        texts={[
          "Che sia una “semplice” piega sino ad un completo restyling  scegli il tuo percorso preferito, ogni pacchetto comprende tutto il necessario.",
          "Zero pensieri, zero sorprese solo tanto relax.."
        ]}
        revertOrder={false}
        headerTextColor={"accentWoman"}
      >
        <div className="flex 2xl:flex-row flex-col align-center 2xl:justify-start justify-center gap-12 w-full">
          <ServiceIcon icon="bg-service-clock" header="Assolo"  headerTextColor={"accentWoman"}/>
          <ServiceIcon icon="bg-service-violino" header="Accordo"  headerTextColor={"accentWoman"}/>
          <ServiceIcon icon="bg-service-woman" header="Sinfonia"  headerTextColor={"accentWoman"}/>
          <ServiceIcon icon="bg-service-lotus" header="Opera"  headerTextColor={"accentWoman"}/>
        </div>
      </ImageAndTextDivider>
    </div>
  )
}

export default LocationAndServicesWoman;